<template>
  <div class="details">
    <h4>
      PROJECT DETAILS
    </h4>

    <div class="table">
      <div class="tbody">
        <div
          v-for="(row, rIdx) in rows"
          :key="rIdx"
          class="tr"
        >
          <div class="td w-48">
            {{ row.label }}
          </div>

          <div class="td flex">
            <template v-if="row.key === 'location'">
              <span class="block flex-1">
                Latitude: {{ contentItem.rows.location.latitude }}
              </span>

              <span class="block flex-1">
                Longitude: {{ contentItem.rows?.location.longitude }}
              </span>
            </template>

            <template v-else-if="row.key === 'timeframe'">
              {{ formatSlashDate(contentItem.rows.timeframe.startDate) }} - {{ formatSlashDate(contentItem.rows.timeframe.endDate) }}
            </template>

            <template v-else-if="row.key === 'stakeholders'">
              {{ contentItem.rows.stakeholders }}
            </template>

            <template v-else>
              {{
                row.isCurrency
                  ? formatCurrency(contentItem.rows[row.key])
                  : (contentItem.rows[row.key])
              }}
            </template>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { useStringFormatter, useDateFormatter } from '@/composables';

const { formatCurrency } = useStringFormatter();
const { formatSlashDate } = useDateFormatter();

const props = defineProps({
  contentItem: {
    type: Object,
    required: true,
  },
});

const rows = [
  { key: 'owners', label: 'Project Owner/s / Implementing Entity' },
  { key: 'timeframe', label: 'Project Timeframe' },
  { key: 'projectSector', label: 'Project Sector / Industry' },
  { key: 'budget', label: 'Proposed Budget', isCurrency: true },
  { key: 'stakeholders', label: 'Stakeholders / Social Partners' },
  { key: 'location', label: 'Project Location\n' },
];
</script>
